<template>
  <div>
    <div class="index-step" v-if="typeId == 2">
      <div class="m-conter" v-if="step == 1">
        <div class="sconter1 sconter-all sconter-select">
          1
          <div class="s1 s1-color">业务选择</div>
        </div>
        <div class="sconter2 sconter-all">
          2
          <div class="s1">照片上传</div>
        </div>
        <div class="sconter3 sconter-all">
          3
          <div class="s1">信息填写</div>
        </div>
        <div class="sconter4 sconter-all">
          4
          <div class="s1">复印用途</div>
        </div>
        <div class="sconter5 sconter-all">
          5
          <div class="s1">支付金额</div>
        </div>
        <div class="back-line"></div>
        <div class="back-line1"></div>
      </div>
      <div class="m-conter" v-if="step == 2">
        <div class="sconter1 sconter-all sconter-select">
          1
          <div class="s1 s1-color">业务选择</div>
        </div>
        <div class="sconter2 sconter-all sconter-select">
          2
          <div class="s1 s1-color">照片上传</div>
        </div>
        <div class="sconter3 sconter-all">
          3
          <div class="s1">信息填写</div>
        </div>
        <div class="sconter4 sconter-all">
          4
          <div class="s1">复印用途</div>
        </div>
        <div class="sconter5 sconter-all">
          5
          <div class="s1">支付金额</div>
        </div>
        <div class="back-line"></div>
        <div class="back-line2"></div>
      </div>
      <div class="m-conter" v-if="step == 3">
        <div class="sconter1 sconter-all sconter-select">
          1
          <div class="s1 s1-color">业务选择</div>
        </div>
        <div class="sconter2 sconter-all sconter-select">
          2
          <div class="s1 s1-color">照片上传</div>
        </div>
        <div class="sconter3 sconter-all sconter-select">
          3
          <div class="s1 s1-color">信息填写</div>
        </div>
        <div class="sconter4 sconter-all">
          4
          <div class="s1">复印用途</div>
        </div>
        <div class="sconter5 sconter-all">
          5
          <div class="s1">支付金额</div>
        </div>
        <div class="back-line"></div>
        <div class="back-line3"></div>
      </div>
      <div class="m-conter" v-if="step == 4">
        <div class="sconter1 sconter-all sconter-select">
          1
          <div class="s1 s1-color">业务选择</div>
        </div>
        <div class="sconter2 sconter-all sconter-select">
          2
          <div class="s1 s1-color">照片上传</div>
        </div>
        <div class="sconter3 sconter-all sconter-select">
          3
          <div class="s1 s1-color">信息填写</div>
        </div>
        <div class="sconter4 sconter-all sconter-select">
          4
          <div class="s1 s1-color">复印用途</div>
        </div>
        <div class="sconter5 sconter-all">
          5
          <div class="s1">支付金额</div>
        </div>
        <div class="back-line"></div>
        <div class="back-line4"></div>
      </div>
      <div class="m-conter" v-if="step == 5">
        <div class="sconter1 sconter-all sconter-select">
          1
          <div class="s1 s1-color">业务选择</div>
        </div>
        <div class="sconter2 sconter-all sconter-select">
          2
          <div class="s1 s1-color">照片上传</div>
        </div>
        <div class="sconter3 sconter-all sconter-select">
          3
          <div class="s1 s1-color">信息填写</div>
        </div>
        <div class="sconter4 sconter-all sconter-select">
          4
          <div class="s1 s1-color">复印用途</div>
        </div>
        <div class="sconter5 sconter-all sconter-select">
          5
          <div class="s1 s1-color">支付金额</div>
        </div>
        <div class="back-line"></div>
        <div class="back-line5"></div>
      </div>
    </div>
    <div class="index-step" v-if="typeId == 1 || typeId == 3">
      <div class="m-conter" v-if="step == 1">
        <div class="sconter1 sconter-all sconter-select">
          1
          <div class="s1 s1-color">业务选择</div>
        </div>
        <div class="sconter2 sconter-all">
          2
          <div class="s1">照片上传</div>
        </div>
        <div class="sconter3 sconter-all">
          3
          <div class="s1">信息填写</div>
        </div>
        <div class="sconter5 sconter-all">
          4
          <div class="s1">支付费用</div>
        </div>
        <div class="back-line"></div>
        <div class="b-line1"></div>
      </div>
      <div class="m-conter" v-if="step == 2">
        <div class="sconter1 sconter-all sconter-select">
          1
          <div class="s1 s1-color">业务选择</div>
        </div>
        <div class="sconter2 sconter-all sconter-select">
          2
          <div class="s1 s1-color">照片上传</div>
        </div>
        <div class="sconter3 sconter-all">
          3
          <div class="s1">信息填写</div>
        </div>
        <div class="sconter5 sconter-all">
          4
          <div class="s1">支付费用</div>
        </div>
        <div class="back-line"></div>
        <div class="b-line2"></div>
      </div>
      <div class="m-conter" v-if="step == 3">
        <div class="sconter1 sconter-all sconter-select">
          1
          <div class="s1 s1-color">业务选择</div>
        </div>
        <div class="sconter2 sconter-all sconter-select">
          2
          <div class="s1 s1-color">照片上传</div>
        </div>
        <div class="sconter3 sconter-all sconter-select">
          3
          <div class="s1 s1-color">信息填写</div>
        </div>
        <div class="sconter5 sconter-all">
          4
          <div class="s1">支付费用</div>
        </div>
        <div class="back-line"></div>
        <div class="b-line3"></div>
      </div>
      <div class="m-conter" v-if="step == 4">
        <div class="sconter1 sconter-all sconter-select">
          1
          <div class="s1 s1-color">业务选择</div>
        </div>
        <div class="sconter2 sconter-all sconter-select">
          2
          <div class="s1 s1-color">照片上传</div>
        </div>
        <div class="sconter3 sconter-all sconter-select">
          3
          <div class="s1 s1-color">信息填写</div>
        </div>
        <div class="sconter5 sconter-all sconter-select">
          4
          <div class="s1 s1-color">支付费用</div>
        </div>
        <div class="back-line"></div>
        <div class="b-line4"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["typeId", "step"]
};
</script>

<style>
</style>
